import React, { Component } from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { CheckCircle2, Wrench, Target, ShieldAlert } from 'lucide-react';
import { PlanYourVisitCTA } from '../components/PlanYourVisitCTA';
export function ReloadingSupplies() {
  useDocumentMeta('Reloading Supplies in Lake Benton, Minnesota | Kjergaard Sports', 'Find bullets, powders, primers, presses, dies, scales, and reloading tools at Kjergaard Sports in Lake Benton, Minnesota.');
  const categories = ['Bullets', 'Powder', 'Primers', 'Shot', 'Wads', 'Hulls', 'Presses', 'Dies', 'Scales', 'Reloading tools'];
  return <div data-id="element-1094">
      <PageHero title="Reloading Supplies in Lake Benton, Minnesota" image="https://cdn.magicpatterns.com/uploads/8918DCMwwSgbp8VrUA2ZyG/reloading-supplies.jpg" alt="Reloading supplies at Kjergaard Sports" data-id="element-1095" />

      <section className="py-20 bg-brand-offwhite" data-id="element-1096">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1097">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-1098">
            <div className="order-2 lg:order-1" data-id="element-1099">
              <img src="https://cdn.magicpatterns.com/uploads/8918DCMwwSgbp8VrUA2ZyG/reloading-supplies.jpg" alt="Reloading supplies selection at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-1100" />
            </div>

            <div className="order-1 lg:order-2" data-id="element-1101">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-1102">
                Components & Tools for the Bench
              </h2>
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-1103">
                For customers who demand precision or simply enjoy the craft of
                building their own ammunition, Kjergaard Sports offers a
                dedicated selection of reloading supplies and equipment.
              </p>

              <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream mb-8" data-id="element-1104">
                <h3 className="font-serif text-xl mb-4" data-id="element-1105">
                  Reloading Supplies We Carry:
                </h3>
                <ul className="grid sm:grid-cols-2 gap-3" data-id="element-1106">
                  {categories.map((item, index) => <li key={index} className="flex items-start" data-id="element-1107">
                      <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-1108" />
                      <span className="text-brand-charcoal/90" data-id="element-1109">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-20" data-id="element-1110">
            <div className="bg-brand-cream p-10 rounded-sm border border-brand-bone" data-id="element-1111">
              <Target className="w-12 h-12 text-brand-hunter mb-6" data-id="element-1112" />
              <h3 className="text-2xl font-serif text-brand-charcoal mb-4" data-id="element-1113">
                Built for Customers Who Value Precision
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-1114">
                Whether you are working up a highly accurate load for a
                long-range rifle or loading volume practice rounds for the
                range, we stock the components and hardware you need to keep
                your press running.
              </p>
            </div>

            <div className="bg-brand-bone p-10 rounded-sm border border-brand-cream" data-id="element-1115">
              <Wrench className="w-12 h-12 text-brand-hunter mb-6" data-id="element-1116" />
              <h3 className="text-2xl font-serif text-brand-charcoal mb-4" data-id="element-1117">
                Hardware & Tools
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-1118">
                Beyond consumables like powder and primers, we carry the
                physical tools required for the bench, including presses, dies,
                scales, and case prep equipment.
              </p>
            </div>
          </div>

          <div className="bg-brand-charcoal text-brand-offwhite p-10 rounded-sm flex flex-col md:flex-row items-start gap-8 max-w-5xl mx-auto" data-id="element-1119">
            <ShieldAlert className="w-16 h-16 text-brand-leather flex-shrink-0" data-id="element-1120" />
            <div data-id="element-1121">
              <h3 className="text-2xl font-serif mb-4" data-id="element-1122">Safety Comes First</h3>
              <p className="text-brand-offwhite/80 leading-relaxed mb-0" data-id="element-1123">
                Reloading requires strict adherence to published load data from
                powder and bullet manufacturers. Kjergaard Sports provides the
                components and tools, but we do not provide load data, powder
                charges, recipes, or technical reloading instructions. Always
                consult current, published reloading manuals for safe practices.
              </p>
            </div>
          </div>
        </div>
      </section>

      <PlanYourVisitCTA data-id="element-1124" />
    </div>;
}